var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center width-100"},[_c('hr',{class:_vm.classes,style:(_vm.styleObj)})])}
var staticRenderFns = []

export { render, staticRenderFns }